import { Subscription } from '@/store/user/types';

export type OneTimePurchase = {
	content_type: string;
	id: string;
	created_at: string;
	payment_processor: string;
	processor_purchase_id: string;
	program_id: string;
	purchased_at: string;
	updated_at: string;
	user_id: string;
};

export type PurchaseRequestResponse = Subscription | OneTimePurchase | Record<string, unknown>;

export const isSubscriptionResponse = (data: PurchaseRequestResponse): data is Subscription => {
	return 'valid' in data;
};

export const isOneTimePurchaseResponse = (data: PurchaseRequestResponse): data is OneTimePurchase => {
	return !('valid' in data);
};

export type RequiresActionResponse = {
	requiresAction: boolean;
	clientSecret: string;
	customerId: string;
	paymentIntentId: string;
	subscriptionId?: string;
};
